import Component from './message_template_dialog.vue'
export default Component
